import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { CentrosViewModel } from "src/app/_core/models/centros/centro.model";
import { CentroPageComponent } from "../../../pages/centro/centro.page";

@Component({
  selector: "app-centro-user-report-card",
  templateUrl: "./centro-user-report-card.component.html",
  styleUrls: ["./centro-user-report-card.component.scss"],
})
export class CentroUserReportCardComponent implements OnInit, AfterViewInit {
  @Input() mainFormGroup: FormGroup;
  @Input() centro!: CentrosViewModel;
  @Input() parent: CentroPageComponent;
  @Input() fotophotoEmReporte: string | ArrayBuffer;
  @Input() fotophotoEmAmbiental: string | ArrayBuffer;
  @Input() fotophotoEmSocial: string | ArrayBuffer;
  @Input() fotophotoEmValPrincipal: string | ArrayBuffer;
  @Input() fotophotoEmValApoyo: string | ArrayBuffer;
  @ViewChild("nombreReporteInput") nombreReporteInput: ElementRef;
  @ViewChild("nombreAmbientalInput") nombreAmbientalInput: ElementRef;
  @ViewChild("nombreSocialInput") nombreSocialInput: ElementRef;
  @ViewChild("nombreValPrincipalInput") nombreValPrincipalInput: ElementRef;
  @ViewChild("nombreValSupportInput") nombreValSupportInput: ElementRef;
  @ViewChild("photoEmReporte") photoEmReporte: ElementRef;
  @ViewChild("photoEmAmbiental") photoEmAmbiental: ElementRef;
  @ViewChild("photoEmSocial") photoEmSocial: ElementRef;
  @ViewChild("photoEmValPrincipal") photoEmValPrincipal: ElementRef;
  @ViewChild("photoEmValApoyo") photoEmValApoyo: ElementRef;

  constructor(public translate: TranslateService) {}

  async ngAfterViewInit(): Promise<void> {
    await this.parent.loadValues(
      this.fotophotoEmReporte,
      this.fotophotoEmAmbiental,
      this.fotophotoEmSocial,
      this.fotophotoEmValPrincipal,
      this.fotophotoEmValApoyo
    );
  }

  // Events
  ngOnInit(): void {}

  getCentroUserReportFormGroup(): FormGroup {
    return this.mainFormGroup?.get("centroUserReport") as FormGroup;
  }
}
